import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SessionsValuesModule } from 'app/my-account/components/session-values/session-values.module';

import { AddressCardComponent } from './address-card.component';

@NgModule({
	declarations: [AddressCardComponent],
	imports: [
		CommonModule,
		FreudButtonModule,
		TranslateModule,
		FreudDialogModule,
		FreudTooltipModule,
		SessionsValuesModule,
	],
	exports: [AddressCardComponent],
})
export class AddressCardModule {}
